import { createNetworkStatusNotifier } from 'react-apollo-network-status';

export const { link: networkStatusLink, useApolloNetworkStatus } = createNetworkStatusNotifier();
